"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Utilitná funkcia pre naformátovanie čísla
 * @param {number} - Číslo pre naformátovanie
 * @param {number} - Počet desatinných miest, na ktoré sa číslo zaokrúhli
 * @param {string} - Oddeľovač desatinných miest
 * @param {string} - Oddeľovač tisícov
 * @returns {string} - Naformátované číslo
 * @example
 * ```javascript
 * import formatNumber from 'utilities/lib/formatNumber';
 * const number = 1234.543252;
 *
 * console.log(formatNumber(number)); // 1 234,54
 * console.log(formatNumber(number, 4)); // 1 234,5433
 * console.log(formatNumber(number, 4, '.')); // 1 234.5433
 * console.log(formatNumber(number, 4, '.', '.')); // 1.234.5433
 * ```
 */

function formatNumber(n, c, d, t) {
  if (c === void 0) {
    c = 2;
  }

  if (d === void 0) {
    d = ',';
  }

  if (t === void 0) {
    t = ' ';
  }

  var b = n.toString();
  var s = parseFloat(b) < 0 ? '-' : '';
  var i = String(Number.parseInt(b = Math.abs(+b || 0).toFixed(c), 10));
  var j = i.length;
  j = j > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(parseFloat(b) - parseFloat(i)).toFixed(c).slice(2) : '');
}

exports.default = formatNumber;